<template>
    <div class="flex h-screen bg-theme-bg2">
        <!-- Sidebar -->
        <NewSidebar />
        <!-- Main Content -->
        <div class="flex-1 flex flex-col overflow-hidden">
            <Header />
            <main
              class="flex-1 bg-theme-surface"
              :class="isChatsRoute ? 'overflow-hidden' : 'p-6 overflow-y-auto overflow-x-hidden'"
            >
                <router-view /> <!-- Renders Account, Orders, etc. -->
            </main>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Header from '@/components/Header.vue';
import NewSidebar from '@/components/New-Sidebar.vue';

const route = useRoute();
const isChatsRoute = computed(() => route.path === '/new-profile/chats');
</script>